import React from 'react';
import {withRouter} from "react-router-dom";
import style from './MoreInfo.module.scss';
import transactionTypes from '../../../../asset/data/transactionTypes';
import propertyTypes from '../../../../asset/data/propertyTypes';

class MoreInfo extends React.Component {
  render() {
    const { activityTypes = [], adviseTypes = [], states = [], regions = [], realEstate = {} } = this.props.advisor;
    const address = realEstate.address;

    return (
      <div className={style.more_info}>
        <ul>
          <li className={'d-flex'}>
            <div className={`${style.icon} d-flex justify-content-center`}>
              <i className={'icon-apartment'} />
            </div>
            <div className={`${style.content}`}>
              <div>
                <span className={style.key}>نوع فعالیت:</span>
              </div>
              <div className={'mt-1'}>
                {
                  activityTypes.map((item) => {
                    return <span className={style.value}>{propertyTypes.find((i) => i.value === item).label}</span>
                  })
                }
              </div>
              <hr/>
            </div>
          </li>
          <li className={'d-flex'}>
            <div className={`${style.icon} d-flex justify-content-center`}>
              <i className={'icon-headset'} />
            </div>
            <div className={`${style.content}`}>
              <div>
                <span className={style.key}>نوع مشاوره:</span>
              </div>
              <div className={'mt-1'}>
                {
                  adviseTypes.map((item) => {
                    return <span className={style.value}>{transactionTypes.find((i) => i.value === item).label}</span>
                  })
                }
              </div>
              <hr/>
            </div>
          </li>
          <li className={'d-flex'}>
            <div className={`${style.icon} d-flex justify-content-center`}>
              <i className={'icon-area'} />
            </div>
            <div className={`${style.content}`}>
              <div>
                <span className={style.key}>استان:</span>
              </div>
              <div className={'mt-1'}>
                {
                  states.map((item) => {
                    return <span className={style.value}>{item.title}</span>
                  })
                }
              </div>
              <hr/>
            </div>
          </li>
          <li className={'d-flex'}>
            <div className={`${style.icon} d-flex justify-content-center`}>
              <i className={'icon-flag'} />
            </div>
            <div className={`${style.content}`}>
              <div>
                <span className={style.key}>محدوده فعالیت:</span>
              </div>
              <div className={'mt-1'}>
                {
                  regions.map((item) => {
                    return <span className={style.value}>{item.title}</span>
                  })
                }
              </div>
              <hr/>
            </div>
          </li>
          <li className={'d-flex'}>
            <div className={`${style.icon} d-flex justify-content-center`}>
              <i className={'icon-pin'} />
            </div>
            <div className={`${style.content}`}>
              <div>
                <span className={style.key}>آدرس املاک:</span>
              </div>
              <div className={'mt-1 mb-3'}>
                <span className={style.value}>{address}</span>
              </div>
            </div>
          </li>
        </ul>
      </div>
    );
  }
}

export default withRouter(MoreInfo);
